"use client";

import React from "react";

export function Layout1() {
  return (
    /* TADY JE TA OPRAVA ID: Změněno na "o-nas" pro plynulé sjíždění */
    <section id="o-nas" className="bg-wood-cream text-black font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 gap-y-12 md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
          <div>
            <p className="mb-3 font-semibold md:mb-4 uppercase tracking-wider">O nás</p>
            {/* Nadpis - Gelasio, velikost 56px na desktopu */}
            <h1 className="mb-5 text-[36px] font-bold font-serif leading-[1.1] md:mb-6 md:text-[56px]">
              Tesařství Šindelář, řemeslo již třetí generací
            </h1>
            {/* Text - Inter, velikost 18px (text-lg) */}
            <p className="text-base md:text-lg leading-[1.6]">
            Jsme rodinná tesařská dílna z Ústeckého regionu, která se několik generací věnuje tradičnímu řemeslu. Naší specialitou je stavba a komplexní obnova roubenek a dalších památkově chráněných objektů. Naší filozofií je přesvědčení ke každému projektu přistupovat s respektem k původním postupům, materiálům i architektuře. Nejde nám o moderní napodobeniny, ale o skutečné stavby, které odpovídají historickému charakteru a obstojí další desítky let.
            </p>
          </div>
          <div>
            <img
              /* TADY JSME NECHALI TVOJE OBRÁZKY, jen přidali / pro jistotu */
              src="/img/Image sindelar.png"
              className="w-full object-cover rounded-lg"
              alt="Tesařství Šindelář - rodinná tradice"
            />
          </div>
        </div>
      </div>
    </section>
  );
}